module.exports = __webpack_public_path__ + "static/media/cust-journey@2x.cfbcf7e2.png";